<template>
  <ExamDo @submit="onSubmit" :isFile="1">
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread :isFile="1"></ExamIndexBread>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPoint' }">专项练习</router-link>
        <span class="slash">/</span>
        <span class="current">{{ specialName }}</span>
      </div>
    </template>
  </ExamDo>
</template>
<script>
import ExamDo from "./components/ExamDo.vue";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamSpecialDo",
  components: {
    ExamDo,
    ExamIndexBread,
  },
  data() {
    return {
      specialId: this.$route.query.specialId,
      specialName: this.$route.query.specialName,
    };
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        name: "ExamSpecialReport",
        query: {
          id: this.$route.query.id,
          specialId: this.specialId,
        },
      });
    },
  },
};
</script>
